// Píldora de la ficha: si el vendedor tiene wallet PCF y, de ser así, los últimos 4 de su CLABE.
import { usePermissions } from '@/kit';
import { linkedWalletText, walletBadgeText } from '@/domains/retail/negocios/components/walletLink';
import { StatusPill } from '@/shared/patterns/Pills';
import { useRosterUser } from '../../lib/useRoster';
import type { SellerRow } from '../lib/sellersTable';

const READ_PERMISSIONS = ['retail.user.list', 'retail.user.read'] as const;

function WalletPill({ retailerId, sellerId }: { retailerId: string; sellerId: string }) {
    const { user } = useRosterUser(retailerId, sellerId);
    if (user === null) return null;
    const linked = linkedWalletText(user);
    return (
        <StatusPill tone={linked ? 'success' : 'neutral'} title={linked ?? 'Sin wallet vinculada'}>
            {walletBadgeText(user)}
        </StatusPill>
    );
}

/** Sin permiso de leer usuarios, sin cadena o sin padrón no se pinta nada ni se consulta. */
export function SellerWalletBadge({
    row,
    retailerId,
}: {
    row: SellerRow;
    retailerId: string | null;
}) {
    const { hasPermission } = usePermissions();
    const canRead = READ_PERMISSIONS.some((permission) => hasPermission(permission));
    if (!canRead || retailerId === null || row.status === null) return null;
    return <WalletPill retailerId={retailerId} sellerId={row.sellerId} />;
}
